module.exports = __webpack_public_path__ + "images/help/project-list-new-tips-5e6e0856adb569abbbf5ce951e8ba0b1.png";